/* eslint-disable no-unused-vars */

// Объекты, которые выпадают для игрока (их нужно ловить или уворачиваться от них)
// у них та же механика что и у MovableObjectModel

import gameObjectsSettings from '../constants/gameObjectsSettings/gameObjectsSettings';
import lootObjectsSettingsByType from '../constants/gameObjectsSettings/lootObjectsSettingsByType';
import { getRandomInt } from '../helpers/mathMethods';
import MovableObjectModel from './movableObjectModel';

export default class LootMovableObjectModel extends MovableObjectModel {
    // Опция лута, то, как он влияет на игрока
    #option;
    #isPt;
    get option() {
        return this.#option;
    }

    #maxOffsetByXPx;

    hided;

    // get currentYInGame() {
    //     return this.y + this.startPoint.y * incrementPxToCoord;
    // }

    constructor(type, { option }) {
        super(type);

        this.#option = option;

        this.setObjectSettings(type, option);
        this.setMaxOffset();
    }

    setObjectSettings(type, option) {
        this.lootObjectSettings = {
            ...gameObjectsSettings[type],
            ...(lootObjectsSettingsByType[option] || {})
        };
    }

    updateGameSizes(args) {
        super.updateGameSizes(args);

        this.#isPt = args.width / args.height < 2;

        this.setMaxOffset(args);
    }

    setMaxOffset(args) {
        if (!args) {
            this.#maxOffsetByXPx = this.lootObjectSettings.maxOffsetByXPx;

            return;
        }

        // TODO вынести этот параметр
        if (this.#isPt) {
            this.#maxOffsetByXPx = this.lootObjectSettings.maxOffsetByXPtPx;
        } else {
            this.#maxOffsetByXPx = this.lootObjectSettings.maxOffsetByXPx;
        }

        this.setEndPoint();
    }

    setEndPoint() {
        const endPointX = this.#isPt ? this.lootObjectSettings.endPointPt.x : this.lootObjectSettings.endPoint.x;

        this.endPoint.y = this.#isPt ? this.lootObjectSettings.endPointPt.y : this.lootObjectSettings.endPoint.y;

        if (typeof this.#maxOffsetByXPx !== 'number') {
            this.endPoint.x = endPointX;
        } else {
            this.endPoint.x = getRandomInt(-1 * this.#maxOffsetByXPx, this.#maxOffsetByXPx);
        }

        this.endPoint.scale = this.#isPt ? this.lootObjectSettings.endPointPt.scale : this.lootObjectSettings.endPoint.scale;

        // console.log(this.#option, this.endPoint);

        this.setObjectVelocityVectors();
        this.setLineEquationScaleFromY();
    }

    init(params) {
        this.#option = params.option || this.#option;

        this.setObjectSettings(this.type, this.#option);
        // this.setEndPoint();

        // console.log(params);

        super.init({ ...params });
    }

    hide() {
        this.hided = true;
    }

    show() {
        this.hided = false;
    }
}
